export default "__VITE_ASSET__CwBweFCx__"